export default {
  // Admin Dashboard
  adminDashboard: "Admin Dashboard",
  adminPanel: "Admin Panel",
  manageCampaigns: "Manage Campaigns",
  campaignManagement: "Campaign Management",
  allCampaigns: "All Campaigns",
  
  // Campaign Status
  statusPending: "Pending",
  statusActive: "Active",
  statusCompleted: "Completed",
  statusCancelled: "Cancelled",
  statusDraft: "Draft",
  
  // Actions
  approveCampaign: "Approve Campaign",
  rejectCampaign: "Reject Campaign",
  viewDetails: "View Details",
  editCampaign: "Edit Campaign",
  deleteCampaign: "Delete Campaign",
  
  // Filters & Sort
  filterByStatus: "Filter by Status",
  sortBy: "Sort by",
  searchCampaigns: "Search Campaigns",
  
  // Statistics
  totalCampaigns: "Total Campaigns",
  activeCampaigns: "Active Campaigns",
  pendingApproval: "Pending Approval",
  totalRevenue: "Total Revenue",
  
  // Messages
  campaignApproved: "Campaign approved successfully",
  campaignRejected: "Campaign rejected",
  campaignDeleted: "Campaign deleted",
  confirmDelete: "Are you sure you want to delete this campaign?",
  
  // Errors
  errorLoadingCampaigns: "Error loading campaigns",
  errorUpdatingStatus: "Error updating status",
  errorDeletingCampaign: "Error deleting campaign",
} as const;
